/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Notification, Paragraph, Typography } from '@telus-uds/components-web';
import RichText from '../richText';
import { BLOCKS } from '@contentful/rich-text-types';

const noteParagraphOptions = options => ({
  ...options,
  renderNode: {
    ...(options && options.renderNode),
    [BLOCKS.PARAGRAPH]: (node, key, next) => (
      <Paragraph
        key={key}
        style={{ lineHeight: '1.5rem', margin: 0, marginBottom: '0.5em' }}
      >
        <Typography>{next(node.content, key, next)}</Typography>
      </Paragraph>
    )
  }
});

const Note = ({
  type = 'text',
  text = '',
  data,
  options,
  isWarningMessage = false,
  isShowNoteBackground,
  isItalicNote,
  isColorRed,
  noteStyle = {}
}) => {
  const resolvedColor = noteStyle && noteStyle.color;
  const renderTextNote = () => {
    const prefixMatch = /^(\s*note\s*:)([\s\S]*)$/i.exec(text);
    if (prefixMatch) {
      // theme-allium's Typography `bold` variant is a no-op for default body
      // text, so the "Note:" prefix is bolded via a scoped font-weight:700
      // !important rule (see .note-bold-prefix in style.css).
      return (
        <Typography block={!isShowNoteBackground}>
          <span className="note-bold-prefix">{prefixMatch[1]}</span>
          {prefixMatch[2]}
        </Typography>
      );
    }
    return <Typography block={!isShowNoteBackground}>{text}</Typography>;
  };
  const content =
    type === 'richText' ? (
      <RichText
        data={data}
        options={
          isShowNoteBackground
            ? noteParagraphOptions(options)
            : options
        }
        isItalicNote={isItalicNote}
        isColorRed={isColorRed}
        textColor={resolvedColor}
      />
    ) : (
      renderTextNote()
    );

  if (isShowNoteBackground) {
    const notificationProps = isWarningMessage
      ? { variant: { validation: 'warning' } }
      : {};
    return (
      <div style={{ marginTop: '0.5rem', marginBottom: '0.5rem', width: 'fit-content', maxWidth: '100%' }}>
        <Notification
          {...notificationProps}
          copy="en"
        >
          <div className="note-notification-content" style={{ margin: 0, padding: 0 }}>
            {content}
          </div>
        </Notification>
      </div>
    );
  }

  return (
    <div
      className="informational_message_without_border"
      style={{ width: 'fit-content', maxWidth: '100%', ...noteStyle }}
    >
      <div className="frg-body-font-14px wrap-white-space">
        {content}
      </div>
    </div>
  );
};

Note.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  isColorRed: PropTypes.bool,
  isItalicNote: PropTypes.bool,
  isShowNoteBackground: PropTypes.bool,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }),
  isWarningMessage: PropTypes.bool,
  noteStyle: PropTypes.object,
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

export const BlueBannerNote = (props) => (
  <Note {...props} isShowNoteBackground isItalicNote={false} />
);

export default Note;
